export default __webpack_public_path__ + "static/media/misc-drawerB-480w.59aa77d8.webp";